<!--
 * @Author: sjk
 * @Date: 2020-09-16 16:54:41
 * @LastEditTime: 2020-10-22 16:43:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\pages\timetask\taskhistory.vue
-->

<template>
  <div>
    <!-- 搜索框 -->
    
    <!-- jobgroup:'',//任务分组
        jobname:'',//任务名称
        jobstatus:1,//任务状态
        beanclass:'',//任务路径
        dealtstatus:''//处理状态 -->
      
    <a-card title="详情">
       <v-gobackbutton slot="extra" >返回</v-gobackbutton>
      <a-form layout="inline" @submit="handleSubmit" :form="form">
   
           <a-form-item label="任务状态">
            <a-select v-model="searchP2.isplaysucceed"  placeholder="" style="width:100px;">
                <a-select-option value="">
                全部
                </a-select-option>
                <a-select-option value="1">
                成功
                </a-select-option>
                <a-select-option value="0">
                失败
                </a-select-option>
                <a-select-option value="3">
                处理中
                </a-select-option>
                <a-select-option value="4">
                未处理
                </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-model-item  label="开始日期" prop="starttime">
            <a-date-picker v-model="searchP2.starttime" format="YYYY-MM-DD" />
         </a-form-model-item>
         <a-form-model-item  label="结束日期" prop="endtime">
            <a-date-picker  v-model="searchP2.endtime"   format="YYYY-MM-DD" />
         </a-form-model-item>
         
          <a-form-item>
              <a-button
                  type="primary"
                  htmlType="submit"
                  :key="this.loading.key"

              >筛选</a-button>
          </a-form-item>
          <a-form-item>
            <a-button
                    type="default"
                    htmlType="submit"
                    :key="this.loading.key"
                    @click="handleSearchReset"
                >重置</a-button>
            </a-form-item>
      </a-form>
    </a-card>

    <!-- 系统列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
      <span slot="isplaysucceed" slot-scope="text">{{ isplaysucceed[text] }}</span>
    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange(pagination.current)" show-less-items show-quick-jumper />

 
 
  </div>
</template>
<script>
import { mapState } from "vuex";

const isplaysucceed = {
    0: '失败',
    1: '成功',
    3: '处理中',
    4: '未处理'
}

const columns = [
    {
        title: '任务编号',
        dataIndex: 'jobid',
        align: 'center',
        width: 100,
    },
    {
        title: '任务名称',
        dataIndex: 'jobname',
        align: 'center',
        width: 350,
        ellipsis: true,
        
    },
    {
        title: '任务组',
        dataIndex: 'jobgroup',
        align: 'center',
        width: 200,
    },

    {
        title: '执行时间',
        dataIndex: 'createtime',
        align: 'left',
        width: 200,
    },
    {
        title: '状态',
        dataIndex: 'isplaysucceed',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'isplaysucceed' },
    },
    {
        title: '执行任务类',
        dataIndex: 'beanclass',
        align: 'left',
        ellipsis: true,
    },
];



const data = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination:{
                total:0,
                pageSize:0,
                current:1,
            },
            tLoading:true,
            isplaysucceed,
        };
    },
   
    methods: {
        getHistoryList(cpage){
            const { query} = this.$route;    
            let c_params = {
                ...this.searchP2
            }
            c_params = JSON.stringify(c_params);
            c_params = JSON.parse(c_params)
            c_params.endtime = c_params.endtime ?  this.dateFormat('YYYY-mm-dd',new Date(c_params.endtime)) : '';
            c_params.starttime =c_params.starttime ? this.dateFormat('YYYY-mm-dd',new Date(c_params.starttime)): '';
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            c_params.jobid = query.id;
            this.tLoading = true;
            console.log("c_params:"+ c_params);
            this.$store.dispatch({
                type: "timetask/selectHistory",
                params:c_params
            }).then((res)=>{
                console.log("res:"+c_params);
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.pagination.total = result.totalRecords;
                this.pagination.pageSize = result.pageSize;
                this.pagination.current = result.page;
            })
        },
        handlePageChange(c_p){
            console.log("页码："+c_p)
            this.getHistoryList(c_p)
        },
        handleSearchReset(){
            this.$store.dispatch({
                type: "timetask/getEmptyHistorySearch",
                showMsg: false
            })  
        },
       
        handleSubmit(e){
            e.preventDefault();
            this.getHistoryList();
        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },
    },
    computed:{
        ...mapState('timetask', {
            searchP2: state => state.searchP2,
        })
    },
    components:{
    },
    mounted(){
        const { query} = this.$route;    

        this.$store.dispatch({
            type: "timetask/selectHistory",
            params:query
        }).then((res)=>{
            console.log("res:"+res);
            this.tLoading = false;
            let result = res.data.data;
            this.data = result.list;
            this.pagination.total = result.totalRecords;
            this.pagination.pageSize = result.pageSize;
            this.pagination.current = result.page;
        })
            
    }
    
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
